




























































































import { Component, Vue } from "vue-property-decorator";
import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src
import Brands from "@/components/Brands.vue";
import Services from "@/components/Services.vue";
import Outlets from "@/components/Outlets.vue";
import AboutUs from "@/components/AboutUs.vue";
import News from "@/components/News.vue";
import ContactUs from "@/components/ContactUs.vue";
import Menu from "@/components/Menu.vue";

@Component({
  components: {
    HelloWorld,
    Brands,
    Services,
    Outlets,
    AboutUs,
    ContactUs,
    Menu,
    News,
  },
})
export default class Home extends Vue {
  private outlets: any = [];
}
